export class KakaoLoginError extends Error {
  //  사용자에게 보여줄 간략한 에러
  _error: string;
  // 내부에서 트래킹할 때 사용할 디테일한 에러
  _errorDescription?: string;
  constructor({
    error,
    errorDescription,
  }: {
    error: string;
    errorDescription?: string;
  }) {
    super();
    this._error = error;
    this._errorDescription = errorDescription;
  }

  get error() {
    return this._error;
  }
}
